import { useContext } from "react";
import NonIdealNew from "../../common/NonIdealNew";
import QuickSaleList from "../../container/QuickSale/QuickSaleList";
import { LanguageContext } from "../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { InnerWrapper, MainContainer, TitleAndActionBox } from "../../common";
import { UBButton } from "../../../Libraries";
import withObservables from "@nozbe/with-observables";
import { observeQuickSaleByBusinessCount } from "../../../database/helpers/invoice";
import "./styles.css";
import { PlayIcon } from "../../../assets/icons/icon";
import { useAuthContext } from "../../../context/AuthContext";

const QuickSale = ({ quickSaleListCount }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { business, user } = useAuthContext();

  const handleAddQuickSale = () => {
    triggerLogEvent(analytics, "quick_sale_create");
    navigate("/QuickSale/QuickSaleForm");
  };



  const isNonIdeal = quickSaleListCount <= 0;
  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: I18n.quicksale,
            }}
          >
            <UBButton
              onClick={handleAddQuickSale}
              id={"create_quick_sale"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.add_quick_sale}
            />
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.one_click_sale_faster_transaction}
                subtitle={I18n.speed_up_sales_reduce_wait_times}
                button1Title="add_quick_sale"
                // button2Title="watch_video"
                onButton1Click={handleAddQuickSale}
                loading={false}
                disabledOne={false}
                disabledTwo={false}
                buttonOneId={"create_quick_sale"}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                video_footer={{
                  title: I18n.add_quick_sale,
                  onClick: handleAddQuickSale,
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
              />
            ) : (
              <QuickSaleList business={business} user={user} />
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

const enhance = withObservables([], () => ({
  quickSaleListCount: observeQuickSaleByBusinessCount(
    localStorage.getItem("business_id"),
  ),
}));

export default enhance(QuickSale);
